import { render, staticRenderFns } from "./AddRecipe.vue?vue&type=template&id=5174454c&scoped=true&"
import script from "./AddRecipe.vue?vue&type=script&lang=js&"
export * from "./AddRecipe.vue?vue&type=script&lang=js&"
import style0 from "./AddRecipe.vue?vue&type=style&index=0&id=5174454c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174454c",
  null
  
)

export default component.exports